import {useEffect, useState} from "react";
import {PhoneHQButton, PhoneHQSwitch} from 'ch3-ui-lib';
import {useSelector} from "react-redux";
import {selectUserId} from "../../store/features/Auth/authSlice";
import {
    useGetEnsUserContactQuery,
    useUpsertEnsUserContactMutation,
} from "../../store/features/ens/ensService";
import {PhoneNumberInput} from "../../components/Dialer/components/PhoneInput";

export const EnsContactSection = () => {
    const userId = useSelector(selectUserId);
    const numericUserId = userId ? Number(userId) : null;

    const {data: contact, isLoading} = useGetEnsUserContactQuery(numericUserId ?? 0, {
        skip: numericUserId == null,
    });
    const [save, {isLoading: isSaving}] = useUpsertEnsUserContactMutation();

    const [msisdn, setMsisdn] = useState('');
    const [eligible, setEligible] = useState(true);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        if (!contact) {
            setMsisdn('');
            setEligible(true);
        } else {
            setMsisdn(contact.externalMsisdn != null ? String(contact.externalMsisdn) : '');
            setEligible(contact.ensEligible);
        }
        setDirty(false);
    }, [contact]);

    const handleSave = async () => {
        if (numericUserId == null) return;
        const trimmed = msisdn.trim();
        const value = trimmed === '' ? null : Number(trimmed);
        if (value != null && Number.isNaN(value)) return;
        try {
            await save({userId: numericUserId, externalMsisdn: value, ensEligible: eligible}).unwrap();
            setDirty(false);
        } catch {
            // toast handled in service
        }
    };

    return (
        <div className="flex w-full gap-8 py-4">
            <div className="min-w-[240px] max-w-[240px] py-2">
                <div className="text-body-strong text-ink">Emergency contact</div>
                <div className="mt-1 text-footnote text-ink-muted">
                    External phone number used by Emergency <br/> Notifications when reaching you outside the app.
                </div>
            </div>
            <div className="grid w-full gap-4 rounded-card bg-surface p-4">
                <PhoneNumberInput
                    phqId="profileSettings-ensMsisdnInput"
                    phoneNumber={msisdn || undefined}
                    onPhoneNumberChange={(value) => {
                        setMsisdn(value.toString());
                        setDirty(true);
                    }}
                    onPhoneNumberClear={() => {
                        setMsisdn('');
                        setDirty(true);
                    }}
                    disabled={isLoading}
                />
                <PhoneHQSwitch
                    label="Eligible to receive emergency notifications"
                    checked={eligible}
                    onCheckedChange={() => {
                        setEligible((prev) => !prev);
                        setDirty(true);
                    }}
                />
                <div className="flex justify-end">
                    <PhoneHQButton size="sm" disabled={!dirty || isSaving} onClick={handleSave} phq-id="profileSettings-ensSaveBtn">{isSaving ? 'Saving…' : 'Save emergency contact'}</PhoneHQButton>
                </div>
            </div>
        </div>
    );
};
